import type { Router, RouteRecordRaw } from 'vue-router'
import type { PermissionScope, Profile } from '../types'
import { defineStore } from 'pinia'
import { clone } from 'ramda'
import { computed, ref } from 'vue'

// todo 需要拆分，两个后台类型不同
export const useProfileStore = defineStore('profile', () => {
  const scope = ref<PermissionScope>()
  const profile = ref<Profile | null>(null)

  const cinemaId = computed(() => profile.value?.cinemaId ?? 0)

  const name = computed(() => {
    return profile.value?.name ?? ''
  })

  const isSuper = computed(() => {
    return profile.value?.super ?? false
  })

  const permissions = computed(() => {
    return profile.value?.permissions ?? []
  })

  function firstPermissedRoute(router: Router) {
    function walkRoute(route: RouteRecordRaw): RouteRecordRaw | null {
      if (isSuper.value) return route

      const p = route.meta?.permissions as string | string[] | undefined
      if (!p) {
        if (!route.children) return null
        return finder(route.children)
      }

      const pList = Array.isArray(p) ? p : [p]
      const hasPermission = pList.some((permission) => {
        return permissions.value.includes(permission)
      })

      if (hasPermission) return route
      if (!route.children) return null

      return finder(route.children)
    }

    function finder(list: RouteRecordRaw[]): RouteRecordRaw | null {
      if (list.length === 0) {
        return null
      }

      for (const route of list) {
        const found = walkRoute(route)
        if (found) {
          return found
        }
      }
      return null
    }

    const routes = router.getRoutes().find(r => r.name === 'Root')?.children ?? []
    return finder(routes)
  }

  function updateProfile(newProfile: Profile | null) {
    profile.value = clone(newProfile)
  }

  function setScope(s: PermissionScope) {
    scope.value = s
  }

  return {
    scope,
    profile,
    cinemaId,
    name,
    isSuper,
    permissions,
    updateProfile,
    setScope,
    firstPermissedRoute,
  }
})
